import React from 'react';
import RenderRevisionNodes from '../../../Documents/components/RenderRevisionNodes';

/**
 * NewPreview Component
 * Shows how the target document will look after copy operation
 * For document copy: Uses the source document structure
 * For node copy: Uses target document with inserted section at the selected position
 */
const NewPreview = ({ originalData, sourceData, targetDocument, newData }) => {
  if (!newData || !targetDocument) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        color: '#666'
      }}>
        <p>Loading new document preview...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Use existing Document rendering components with computed new data */}
      <RenderRevisionNodes
        partRef={targetDocument.partId}
        procedureRevRef={targetDocument.revisionId}
        partNumber={targetDocument.partNumber}
        revision={targetDocument.revision}
        disabled={true} // Read-only view
        showCheckbox={false} // Hide checkboxes in preview
        preloadedData={newData} // Pass the computed new data structure
        forceShowChildHeadings={true} // Ensure labels show even without checkboxes
      />
    </div>
  );
};

export default NewPreview;
